import baseService from "@common/externos/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let http = baseService(store, tbRoute);

const apiDef = {
  getModulosAtivosByIdSistema() {
    const alias = "ObrasParticulares";
    return http.get(
      `${commonRoute}/SistemaExterno/modulosAtivosByAlias/${alias}/noauth`
    );
  },
  getParametro() {
    const funcionalidade = "ObrasParticulares";
    return http.get(
      `/ParametroExterno/ParametroFuncionalidade/${funcionalidade}`
    );
  }

};

export default apiDef;
